import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import { RouteElements } from 'app/agriculture/router/types';
import { NotFound } from 'app/agriculture/routes/NotFound';
import { InfraCreate } from 'app/agriculture/routes/Infra/InfraCreate/InfraCreate';
import { InfraDetails } from 'app/agriculture/routes/Infra/InfraDetails/InfraDetails';
import { InfraEdit } from 'app/agriculture/routes/Infra/InfraEdit/InfraEdit';
import { InfraDelete } from 'app/agriculture/routes/Infra/InfraDelete/InfraDelete';

export function infraRouteElements(infraType: InfraType): RouteElements {
    return {
        Create: { Component: () => <InfraCreate infraType={infraType} /> },
        Edit: { Component: () => <InfraEdit infraType={infraType} /> },
        Delete: { Component: () => <InfraDelete infraType={infraType} /> },
        Details: { Component: () => <InfraDetails infraType={infraType} /> },
        List: { Component: NotFound },
    };
}
